import React, { useContext, useEffect, useState } from "react";
import { Button, Tooltip, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import api from "../../services/api";
import toastError from "../../errors/toastError";
import { AuthContext } from "../../context/Auth/AuthContext";

// Controles da IA de treinamento, sempre visiveis no cabecalho da conversa
// (ticket normal E modal do kanban, pois ambos usam o componente Ticket).
// Sentido (definido pelo usuario): LIGADO = a IA so SUGERE (nao responde o
// cliente). DESLIGADO = a IA RESPONDE direto ao cliente.
//   - Geral (/ai-training-mode): vale p/ todos sem ajuste proprio.
//   - Este contato (/tickets/:id/ai-conversation): override fixo do contato.
const useStyles = makeStyles(theme => ({
  wrap: {
    display: "flex",
    gap: theme.spacing(1),
    flexWrap: "wrap",
    alignItems: "center",
    marginRight: 6
  },
  btn: {
    textTransform: "none",
    fontWeight: 600,
    fontSize: "0.72rem",
    lineHeight: 1.1,
    borderRadius: 999,
    padding: "3px 10px",
    minWidth: 0
  },
  on: { backgroundColor: "#1e6b48", color: "#fff", "&:hover": { backgroundColor: "#17573a" } },
  off: { backgroundColor: "#eceff1", color: "#546e7a", "&:hover": { backgroundColor: "#dfe4e6" } }
}));

const AiTicketControls = ({ ticket }) => {
  const classes = useStyles();
  const { user } = useContext(AuthContext);
  const isAdmin = String(user?.profile || "").toLowerCase() === "admin";

  const [perTicket, setPerTicket] = useState(null);
  const [perBusy, setPerBusy] = useState(false);
  const [global, setGlobal] = useState(null);
  const [globalBusy, setGlobalBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    if (ticket?.id) {
      api
        .get(`/tickets/${ticket.id}/ai-conversation`)
        .then(({ data }) => {
          if (alive) setPerTicket(typeof data?.enabled === "boolean" ? data.enabled : null);
        })
        .catch(() => {});
    }
    api
      .get("/ai-training-mode")
      .then(({ data }) => {
        if (alive) setGlobal(typeof data?.enabled === "boolean" ? data.enabled : null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [ticket?.id]);

  const togglePer = async () => {
    if (perTicket === null || perBusy) return;
    setPerBusy(true);
    try {
      const { data } = await api.post(`/tickets/${ticket.id}/ai-conversation`, {
        enabled: !perTicket
      });
      setPerTicket(typeof data?.enabled === "boolean" ? data.enabled : !perTicket);
    } catch (err) {
      toastError(err);
    }
    setPerBusy(false);
  };

  const toggleGlobal = async () => {
    if (global === null || globalBusy) return;
    const next = !global;
    const msg = next
      ? "Ligar o treinamento geral? A IA passa a SO SUGERIR (nao responde os clientes) para todos os contatos sem ajuste proprio."
      : "Desligar o treinamento geral? A IA passa a RESPONDER os clientes direto para todos os contatos sem ajuste proprio.";
    // eslint-disable-next-line no-alert
    if (!window.confirm(msg)) return;
    setGlobalBusy(true);
    try {
      const { data } = await api.post("/ai-training-mode", { enabled: next });
      setGlobal(typeof data?.enabled === "boolean" ? data.enabled : next);
    } catch (err) {
      toastError(err);
    }
    setGlobalBusy(false);
  };

  return (
    <div className={classes.wrap}>
      {global !== null && isAdmin ? (
        <Tooltip title="Treinamento geral da IA. Ligado: so sugere. Desligado: responde os clientes.">
          <Button
            className={`${classes.btn} ${global ? classes.on : classes.off}`}
            onClick={toggleGlobal}
            disabled={globalBusy}
            size="small"
          >
            {globalBusy ? (
              <CircularProgress size={12} color="inherit" />
            ) : (
              `🌐 Treino geral: ${global ? "ON" : "OFF"}`
            )}
          </Button>
        </Tooltip>
      ) : null}
      {perTicket !== null ? (
        <Tooltip title="IA neste contato. Ligado: so sugere. Desligado: responde este cliente direto.">
          <Button
            className={`${classes.btn} ${perTicket ? classes.on : classes.off}`}
            onClick={togglePer}
            disabled={perBusy}
            size="small"
          >
            {perBusy ? (
              <CircularProgress size={12} color="inherit" />
            ) : (
              `🎓 Este contato: ${perTicket ? "ON" : "OFF"}`
            )}
          </Button>
        </Tooltip>
      ) : null}
    </div>
  );
};

export default AiTicketControls;
